import { initializeApp } from 'firebase/app';
import {
  browserPopupRedirectResolver,
  browserSessionPersistence,
  initializeAuth,
  sendPasswordResetEmail,
  signInWithEmailAndPassword
} from 'firebase/auth';

export const firebaseConfig = {
  apiKey: 'AIzaSyAsdelhCF5ZjIdGa554xdpBKBCcJBdcgAg',
  authDomain: 'followerse-370015.firebaseapp.com',
  projectId: 'followerse-370015',
  storageBucket: 'followerse-370015.appspot.com',
  messagingSenderId: '360229318856',
  appId: '1:360229318856:web:cf3ac82de99c56b987f5fd',
  measurementId: 'G-ELPKJ0RDG3',
};

export const firebaseApp = initializeApp(firebaseConfig);

export const auth = initializeAuth(firebaseApp, {
  persistence: browserSessionPersistence,
  popupRedirectResolver: browserPopupRedirectResolver,
});

export const signIn = async (email: string, password: string) => {
  const result = await signInWithEmailAndPassword(auth, email, password);
  return result;
};

export const restorePassword = async (email: string) => {
  return sendPasswordResetEmail(auth, email);
};
